// Client-side mirror of server ship stats for UI display.
// Keep these values in sync with server/src/game/constants.ts SHIP_STATS.

export type ShipClassKey = 'frigate' | 'destroyer' | 'cruiser' | 'capital';

export const SHIP_STATS: Record<ShipClassKey, { hp: number; dps: number; cost: number; buildTicks: number }> = {
  frigate:   { hp: 10, dps: 4,  cost: 20,  buildTicks: 2 },
  destroyer: { hp: 20, dps: 7,  cost: 40,  buildTicks: 3 },
  cruiser:   { hp: 35, dps: 12, cost: 70,  buildTicks: 4 },
  capital:   { hp: 60, dps: 20, cost: 120, buildTicks: 6 },
};


